import {Flex, Text} from '@chakra-ui/react';
import {IconBlock, TitledSection} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {IAnotherPerson} from 'types';

interface IProps {
  anotherPerson: IAnotherPerson;
}

export const OrderForAnother: FC<IProps> = ({anotherPerson}) => {
  const {t} = useTranslation();

  return (
    <TitledSection title={t('RECIPIENT_DATA')}>
      <IconBlock icon="/icons/delivery.svg">
        <Flex mt="10px" alignItems="center">
          <Text mr="20px" fontWeight="500" color={colors.textGray}>
            {t('USER_NAME')}:
          </Text>
          <Text>{anotherPerson.name}</Text>
        </Flex>
        <Flex mt="10px" alignItems="center">
          <Text mr="20px" fontWeight="500" color={colors.textGray}>
            {t('USER_PHONE_NUMBER')}:
          </Text>
          <Text>{anotherPerson.phone}</Text>
        </Flex>
      </IconBlock>
    </TitledSection>
  );
};
